import { r as registerInstance, h, H as Host } from './index-412826b8.js';
import { T as TRANSITIONS } from './transitions.const-b6f177a8.js';

const UiAnimate = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.enter = TRANSITIONS.fade;
        this.leave = TRANSITIONS.shutdown;
        this.auto = false;
        this.visible = false;
        this.isEntering = false;
        this.isLeaving = false;
    }
    onVisibleChange(newValue) {
        if (newValue) {
            this.showContent();
        }
        else {
            this.hideContent();
        }
    }
    connectedCallback() {
        if (!this.auto) {
            return;
        }
        this.showContent();
    }
    disconnectedCallback() {
        if (!this.auto) {
            return;
        }
        this.hideContent();
    }
    showContent() {
        this.isLeaving = false;
        this.isEntering = true;
    }
    hideContent() {
        this.isEntering = false;
        this.isLeaving = true;
    }
    render() {
        return (h(Host, { key: 'd631eccdee487e5e8d1d1f396ad34ef59380effe', class: {
                ['Ui-Animate']: true,
                [`Ui-Animate__${this.enter}-entering`]: this.isEntering,
                [`Ui-Animate__${this.leave}-leaving`]: this.isLeaving,
            } }, h("slot", { key: '251ced91b350fcbb4fe80d6c25b725a5c51540e8' })));
    }
    static get watchers() { return {
        "visible": ["onVisibleChange"]
    }; }
};

export { UiAnimate as ui_animate };
